import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { ErrorService } from '../errors/error.service';
@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  private readonly MAINTENANCE_SERVICE_URL = '/dpwsvc/v1/ext/code/';
  private readonly MAINTENANCE_CODE: string = 'MAINTENANCE_TYPE';

  private _maintenance: Map<string, string> = new Map<string, string>();

  constructor(private http: HttpClient, private environmentService: EnvironmentService, private errorService: ErrorService) {
  }

  public getMaintenance() {
    this.http.get<Map<string, string>>(this.environmentService.getServer() +
                                      this.MAINTENANCE_SERVICE_URL +
                                      this.MAINTENANCE_CODE).subscribe(res => {
      this._maintenance = res;
    }, error => {
      this.errorService.processError(error);
    });
  }

  public get maintenance(): Map<string, string> {
    return this._maintenance;
  }

}
